module.exports = __webpack_public_path__ + "img/22.db5add47.webp";